const RequestDataConstants = {
  CASE_ORANGE: 'orange',
  CASE_DATE: 'date',
};

export default RequestDataConstants